import {
  buildFdaSubmissionPdfHref,
  field,
  formatReviewTime,
  reviewTimeSources,
} from "../../helpers";
import { fdaDenovoTheme } from "../themes";

const fdaDenovoConfig = {
  label: "FDA De Novo",
  theme: fdaDenovoTheme,
  summary: {
    primary: field("Device name", ["device_name", "product_code_description"]),
    secondary: field("DEN number", ["k_number"], { kind: "id" }),
    columns: [
      field("Company", ["applicant"], {
        className: "hidden lg:block flex-[1.4] min-w-[10rem]",
      }),
      field("Product code", ["product_code"], {
        className: "hidden md:block flex-[0.8] min-w-[6rem]",
        kind: "accent",
      }),
      field("Decision date", ["decision_date"], {
        className: "flex-[0.95] min-w-[7rem]",
      }),
      field("Class", ["device_class"], {
        className: "hidden xl:block flex-[1] min-w-[7rem]",
        kind: "accent",
      }),
    ],
  },
  detail: {
    meta: [
      field("DEN number", ["k_number"], { kind: "id" }),
      field("Product code", ["product_code"], { kind: "accent" }),
      field("Review time", reviewTimeSources, {
        kind: "accent",
        formatValue: formatReviewTime,
      }),
      field("Class", ["device_class"], { kind: "accent" }),
    ],
    sections: [
      {
        title: "Applicant",
        fields: [
          field("Company", ["applicant"]),
          field("City", ["city"]),
          field("State", ["state_code"]),
          field("Country", ["country_code"]),
          field("Contact", ["contact"]),
        ],
      },
      {
        title: "Classification",
        fields: [
          field("Device name", ["device_name"]),
          field("Product code", ["product_code"]),
          field("Product description", ["product_code_description"]),
          field("Class granted", ["device_class"]),
          field("Regulation number", ["regulation_number"]),
        ],
      },
      {
        title: "Review",
        fields: [
          field("Decision date", ["decision_date"]),
          field("Date received", ["date_received"]),
          field("Review time", reviewTimeSources, {
            formatValue: formatReviewTime,
          }),
          field("Decision description", ["decision_description"]),
          field("Review panel", [
             "advisory_committee_description",
            "review_advisory_committee",
            "advisory_committee",
          ]),
          field("Statement or summary", ["statement_or_summary"]),
        ],
      },
    ],
    links: [
      {
        label: "FDA De Novo",
        buildHref: (record, value) =>
          value
            ? `https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfpmn/denovo.cfm?id=${value}`
            : "",
        sources: ["k_number"],
        valueLabel: "Open De Novo record",
      },
      {
        label: "FDA De Novo pdf",
        buildHref: (record, value) => buildFdaSubmissionPdfHref(value),
        sources: ["k_number"],
        valueLabel: "Open De Novo pdf",
      },
    ],
  },
};

export default fdaDenovoConfig;
